<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-分红奖金池-分红明细
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="是否结算">
          <el-select v-model="formInline.is_send" placeholder="是否结算">
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="起始时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker
              size="small"
              v-model="formInline.create_time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="bonus_date" label="分红日期"></el-table-column>
            <el-table-column prop="grade.name" label="分红等级"></el-table-column>
            <el-table-column prop="total_bonus" label="总分红"></el-table-column>
            <el-table-column prop="total_user" label="分红用户数"></el-table-column>
            <el-table-column prop="virtual_user" label="虚拟分红用户数"></el-table-column>
            <el-table-column prop="is_send" label="是否结算">
              <template slot-scope="scope">
                <span v-if="scope.row.is_send == 0">未结算</span>
                <span v-else>已结算</span>
              </template>
            </el-table-column>
            <el-table-column prop="is_grant" label="是否发放">
              <template slot-scope="scope">
                <span v-if="scope.row.is_grant == 0">未发放</span>
                <span v-else>已发放</span>
              </template>
            </el-table-column>
            <el-table-column prop="send_time" label="结算时间" width="150"></el-table-column>
            <el-table-column prop="grant_time" label="结算时间" width="150"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="160">
              <template slot-scope="scope">
                <el-button @click="detail(scope.row)" type="text" size="small">分红详情</el-button>
                <el-button @click="settlement(scope.row)" type="text" size="small" v-if="scope.row.is_send == 0">结算</el-button>
                <el-button @click="grant(scope.row)" type="text" size="small" v-if="scope.row.is_send == 1 && scope.row.is_grant == 0">发放分红</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BonusApi from '@/api/plus/bonus.js';
export default {
  components: {},
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {},
      formInline: {},
      status: ['未开始', '进行中', '已结束']
    };
  },
  created() {

    /*获取列表*/
    this.getTableList();
  },
  methods: {

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      BonusApi.getList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*结算*/
    settlement(row) {
      let self = this;
      BonusApi.settlement({
          bonus_id: row.bonus_id,
        },true)
      .then(data => {
        self.loading = false;
        self.$message({
          message: '恭喜你，结算成功',
          type: 'success'
        });
        this.getTableList();
      })
      .catch(error => {
        self.loading = false;
      });
    },

    /*发放分红*/
    grant(row) {
      let self = this;
      BonusApi.grant({
          bonus_id: row.bonus_id,
        },true)
      .then(data => {
        self.loading = false;
        self.$message({
          message: '恭喜你，发放成功',
          type: 'success'
        });
        this.getTableList();
      })
      .catch(error => {
        self.loading = false;
      });
    },

    /*打开详情*/
    detail(row) {
      let self = this;
      let params = row.bonus_date;
      self.$router.push({
        path: '/plus/bonus/record/detail',
        query: {
          bonus_date: params
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/bonus/record/index.vue